
$(document).ready(function () {
    // Look for .hamburger
    var hamburger = document.querySelector(".hamburger");
    var mainNav = document.querySelector(".main-nav");
    var mainNav2 = document.querySelector(".main-nav2");
    var mainNav3 = document.querySelector(".main-nav3");
    var drawerLayer = document.querySelector(".drawer-layer");
    var stickynavbar = document.querySelector(".navbar-sticky");
    var secondarystickynavbar = document.querySelector(".secondary-sticky-nav");
    var body = document.querySelector("body");

    function toggleDrawer() {
        hamburger.classList.toggle("is-active");
        if (mainNav != null) {
            mainNav.classList.toggle("is-active");
            $('.main-nav1 button').first().focus();
        }
        if (mainNav2 != null) {
            mainNav2.classList.toggle("is-active");
            $('.main-nav2 button').first().focus();
        }
        if (mainNav3 != null) {
            mainNav3.classList.toggle("is-active");
            $('.main-nav3 button').first().focus();
        }

        if (stickynavbar != null) {
            stickynavbar.classList.toggle("is-active");
            stickynavbar.classList.toggle("show");
            body.classList.toggle("disabled");
            $('.navbar-sticky button').first().focus();
        }

        //drawerLayer.classList.toggle("is-active");
    }

    $(".sticky-menu-list.recruitingpage li").on("click", function () {
        $(".navbar-sticky").toggleClass("is-active");
        $(".navbar-sticky").toggleClass("show");
        $(".hamburger").toggleClass("is-active");
        $('body').toggleClass("disabled");
    });

    //add sticky menu class
    if ($(".navbar-sticky").length > 0) {
        $(window).scroll(function () {
            this.scrollY > 20 ? stickynavbar.classList.add("sticky") : stickynavbar.classList.remove("sticky");
            if ($(".navbar-sticky .right-position").length > 0) {
                this.scrollY > 20 ? stickynavbar.classList.add("right-position") : stickynavbar.classList.remove("right-position");
            }
        });
        $("html").css('scroll-padding-top', '100px');

    }
    if ($(".secondary-sticky-nav").length > 0) {
        $(window).scroll(function () {
            this.scrollY > 20 ? secondarystickynavbar.classList.add("sticky") : secondarystickynavbar.classList.remove("sticky");
        });
    }

    // On click
    if (hamburger != null) {
        hamburger.addEventListener("click", function (e) {
            e.preventDefault();
            // Toggle class "is-active"
            if ($('.drawer-layer').length == 0) {
                $('body').append('<div class="drawer-layer is-active"></div>');
            }
            else {
                $('.drawer-layer').remove();
            }

            toggleDrawer();
        });
    }

    $('.sticky-menu-list li').on('click', function () {
        if (!($(".sticky-menu-list").hasClass("nested"))) {
            $(".navbar-sticky").toggleClass("is-active");

            $(".navbar-sticky").toggleClass("show");
            $(".hamburger").toggleClass("is-active");
            $('body').toggleClass("disabled");
        }

    });

    $('.sticky-menu-list.nested li.main-nav-level1').on('click', function () {
        /* $(this).find('.sub-toggler-arrow').toggleClass('active');*/
        if ($('.sticky-menu-list li.main-nav-level2').children('ul.rlist.sub2').filter(':visible').length > 0) {
            return false;
        }

        $(this).siblings('li').children('ul').slideUp('slow');
        $(this).children('ul').slideUp('slow');

        if ($(this).children('ul').is(':hidden') == true) {
            $(this).children('ul').slideDown('slow');
            return false
        }


    });
    $('.sticky-menu-list.nested li.main-nav-level2 button').on('click', function () {
        $(this).find('.sub-toggler-arrow').toggleClass('active');
        $(this).parent().siblings('li').children('ul').slideUp('slow');
        $(this).parent().children('ul').slideUp('slow');

        if ($(this).parent().children('ul').is(':hidden') == true) {
            $(this).parent().children('ul').slideDown('slow');
            return false
        }
    });

    $('.sticky-menu-list.nested li.main-nav-level3').on('click', function () {
        if ($(this).find('a').attr("data-toggle") != undefined) {
            if ($(this).find('a').attr("data-target") == "#ffModal") {
                document.getElementsByClassName("footerfeedback")[0].click();
            }
        }
        else {
            window.location.href = $(this).find('a').attr('href');
        }

    });

    $('body').on('click', '.drawer-layer', function () {
        $('.drawer-layer').remove();
        toggleDrawer();
    });


    $('.sub-toggler').on('click', function () {
        $(this).next().toggle();
        $(this).toggleClass('active');
    });

    $('.sub-toggler-arrow').on('click', function () {
        $(this).next().toggle();
        $(this).toggleClass('active');
    });

    $('.main-nav3 li').click(function () {
        $(this).find('.sub-toggler-arrow').toggleClass('active');
        $(this).siblings('li').children('ul').slideUp('slow');
        $(this).children('ul').slideUp('slow');

        if ($(this).children('ul').is(':hidden') == true) {
            $(this).children('ul').slideDown('slow');
            return false
        }
    });
    $('body').click(function () {
        if ($('.main-nav3 li').children('ul').filter(':visible').length > 0) {
            $('.main-nav3 li').children('ul').filter(':visible').slideUp('slow');
        }
        if ($(".sticky-menu-list").hasClass("nested")) {
            if ($('.sticky-menu-list li.main-nav-level2').children('ul.rlist.sub2').filter(':visible').length > 0) {
                $('.sticky-menu-list li.main-nav-level2').children('ul.rlist.sub2').filter(':visible').slideUp('slow');
            }

            if ($('.sticky-menu-list li.main-nav-level1').children('ul').filter(':visible').length > 0) {
                $('.sticky-menu-list li.main-nav-level1').children('ul').filter(':visible').slideUp('slow');
            }

        }

    });

    //handiling keyboard navigation for main

    var keyboardHandler = function () {
        $('body').on('keydown', function (e) {
            var isMainNavLink = ($(e.target).is('a') || $(e.target).is('button')) && ($(e.target).closest('nav').is('.main-nav3'));
            if (isMainNavLink) {
                if (e.which == 37 || e.which == 38 || e.which == 39 || e.which == 40) {
                    e.preventDefault();
                }
                switch (e.which) {
                    case 37: // left
                        $(e.target).closest('li.main-nav-level1').prev().find('button, a').focus();
                        if ($(e.target).parent().find('ul.rlist.sub').css('display') === 'block')
                            $(e.target).parent().find('ul.rlist.sub').slideUp('slow');
                        else if ($(e.target).closest('ul.rlist.sub').css('display') === 'block')
                            $(e.target).closest('ul.rlist.sub').slideUp('slow');
                        break;
                    case 39: // right
                        $(e.target).closest('li.main-nav-level1').next().find('button, a').focus();
                        if ($(e.target).parent().find('ul.rlist.sub').css('display') === 'block')
                            $(e.target).parent().find('ul.rlist.sub').slideUp('slow');
                        else if ($(e.target).closest('ul.rlist.sub').css('display') === 'block') {
                            $(e.target).closest('ul.rlist.sub').slideUp('slow');
                        }
                        break;
                    case 38: // up
                        $(e.target).closest('li.main-nav-level2').prev().find('button, a').focus();
                        if ($(e.target).parent().find('ul.rlist.sub2').css('display') === 'block')
                            $(e.target).parent().find('ul.rlist.sub2').slideUp('slow');
                        else if ($(e.target).closest('ul.rlist.sub2').css('display') === 'block') {
                            $(e.target).closest('ul.rlist.sub2').slideUp('slow');
                        }
                        break;
                    case 40: // down
                        if ($($(e.target).is('button')) && $(e.target).parent().find('ul.rlist.sub').css('display') === 'none') {
                            $(e.target).click();
                        } else {
                            if ($(e.target).closest('li').hasClass('main-nav-level1')) {
                                $(e.target).parent().find('ul.rlist.sub').find('li').find('a').first().focus();
                            }
                            else {
                                if ($(e.target).closest('li').hasClass('main-nav-level2')) {
                                    $(e.target).closest('li.main-nav-level2').next().find('button').focus();
                                }

                            }
                        }
                        break;
                    default:
                        return; // exit this handler for other keys
                }
            }
        });
    };
    keyboardHandler();

    var expandableAreas = function () {
        $(document).stop().on("mouseup keyup", ".expandable", function (e) {
            var isExpanded = e.currentTarget.getAttribute("aria-expanded");
            if (e.type == "mouseup" || (e.type == "keyup" && (e.keyCode == 13 || e.keyCode == 32))) {
                if (isExpanded == "true") {
                    e.currentTarget.setAttribute("aria-expanded", false);
                    if ($(e.currentTarget).is(".hamburger")) {
                        e.currentTarget.setAttribute("aria-label", "Open menu");
                    }
                } else {
                    e.currentTarget.setAttribute("aria-expanded", true);
                    if ($(e.currentTarget).is(".hamburger")) {
                        e.currentTarget.setAttribute("aria-label", "Close menu");
                    }
                }
            }
        });
    };
    expandableAreas();

    //add nofollow noopener noreferrer to external links except for blogs link
    $("a[href^='http']").each(function () {
        if ($(this).attr('href').indexOf("blog.embracehomeloans.com")<0) {
           $(this).attr('rel', 'nofollow noopener noreferrer');
        }
        
    });
});
